export const defaultIndicatorStyles = {
  desktop: {
    x: '5%',
    y: '30%'
  },
  mobile: {
    x: '0',
    y: '55%'
  }
};
